import React from 'react';
import { 
  Abc as AbcIcon,
  Code as CodeIcon,
  Link as LinkIcon,
  FormatPaint as FormatPaintIcon,
  Description as DescriptionIcon,
  CompareArrows as CompareArrowsIcon,
  Sort as SortIcon
} from '@mui/icons-material';

import ToolAppLayout from '../../layouts/ToolAppLayout';

import CaseConverter from './CaseConverter';
import Base64EncoderDecoder from './Base64EncoderDecoder';
import UrlEncoderDecoder from './UrlEncoderDecoder';
import HtmlEntityEncoderDecoder from './HtmlEntityEncoderDecoder';
import MarkdownToHtml from './MarkdownToHtml';
import TextDiffChecker from './TextDiffChecker';
import LineSorter from './LineSorter';

const toolCategories = [
  {
    name: 'Formatting & Editing',
    tools: [
      { name: 'Case Converter', description: 'Convert text between UPPERCASE, lowercase, camelCase, etc.', path: 'case-converter', icon: <AbcIcon fontSize="small" />, component: CaseConverter },
      { name: 'Text Diff Checker', description: 'Compare two text blocks and highlight differences', path: 'diff-checker', icon: <CompareArrowsIcon fontSize="small" />, component: TextDiffChecker },
      { name: 'Line Sorter', description: 'Sort lines alphabetically or remove duplicates', path: 'line-sorter', icon: <SortIcon fontSize="small" />, component: LineSorter },
    ]
  },
  {
    name: 'Encoding & Decoding',
    tools: [
      { name: 'Base64 Encoder', description: 'Encode or decode strings using Base64', path: 'base64', icon: <CodeIcon fontSize="small" />, component: Base64EncoderDecoder },
      { name: 'URL Encoder', description: 'Safely encode or decode URL parameters', path: 'url-encoder', icon: <LinkIcon fontSize="small" />, component: UrlEncoderDecoder },
      { name: 'HTML Entities', description: 'Escape or unescape HTML special characters', path: 'html-entity', icon: <FormatPaintIcon fontSize="small" />, component: HtmlEntityEncoderDecoder },
    ]
  },
  {
    name: 'Markup',
    tools: [
      { name: 'Markdown to HTML', description: 'Convert Markdown syntax into raw HTML', path: 'markdown-to-html', icon: <DescriptionIcon fontSize="small" />, component: MarkdownToHtml },
    ]
  }
];

function TextToolsApp() {
  return (
    <ToolAppLayout
      title="Text Tools"
      description="Format, encode, compare, and manipulate text strings."
      toolCategories={toolCategories}
      basePath="/text-tools-app"
    />
  );
}

export default TextToolsApp;